import React, { useCallback, useState, memo } from 'react';
import { AutosizedArea } from 'site-modules/shared/components/inventory/autosized-area/autosized-area';
import { noop } from 'lodash-es';

export const AutosizedOnFocus = memo(({ onFocus = noop, onBlur = noop, ...rest }) => {
  const [isCollapsed, setIsCollapsed] = useState(true);

  const handleFocus = useCallback(
    event => {
      setIsCollapsed(false);
      onFocus(event);
    },
    [onFocus]
  );

  const handleBlur = useCallback(
    event => {
      setIsCollapsed(true);
      onBlur(event);
    },
    [onBlur]
  );

  return <AutosizedArea {...rest} isCollapsed={isCollapsed} onFocus={handleFocus} onBlur={handleBlur} withShadow />;
});

AutosizedOnFocus.displayName = 'AutosizedOnFocus';

AutosizedOnFocus.propTypes = {
  ...AutosizedArea.propTypes,
};
